import _ from 'lodash';
import React from 'react';
import Modal from "../Modal";
import CollectionListModal from "./CollectionListModal";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A collection list confirm.
 */
var CollectionListConfirm = function CollectionListConfirm(props) {
  var item = props.item;

  /** Handle cancel event. */
  var handleCancel = function handleCancel(event) {
    return _.invoke(props, 'onCancel', event, item);
  };

  /** Handle confirm event. */
  var handleConfirm = function handleConfirm(event) {
    return _.invoke(props, 'onConfirm', event, item);
  };

  /** Render the component */
  var render = function render() {
    var children = props.children,
      className = props.className,
      content = props.content,
      control = props.control,
      header = props.header,
      open = props.open,
      cancelButton = props.cancelButton,
      confirmButton = props.confirmButton;
    var rest = getRest(CollectionListConfirm, props);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return /*#__PURE__*/_jsx(CollectionListModal, Object.assign({}, rest, {
        className: className,
        open: open,
        onPrimaryClick: handleConfirm,
        onSecondaryClick: handleCancel,
        primaryButton: confirmButton,
        secondaryButton: cancelButton,
        children: children
      }));
    }
    if (! /*#__PURE__*/React.isValidElement(content) && _.isPlainObject(content)) {
      return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
        className: className,
        open: open,
        onPrimaryClick: handleConfirm,
        onSecondaryClick: handleCancel,
        primaryButton: confirmButton,
        secondaryButton: cancelButton,
        children: [Modal.Header.create(header), Modal.Content.create(content)]
      }));
    }
    if (!_.isNil(control)) {
      var Control = control;
      return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
        className: className,
        open: open,
        onPrimaryClick: handleConfirm,
        onSecondaryClick: handleCancel,
        primaryButton: confirmButton,
        secondaryButton: cancelButton,
        children: [/*#__PURE__*/_jsx(Modal.Header, {
          children: header
        }, "header"), /*#__PURE__*/_jsx(Modal.Content, {
          children: /*#__PURE__*/_jsx(Control, Object.assign({}, item))
        }, "content")]
      }));
    }
    return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
      className: className,
      open: open,
      onPrimaryClick: handleConfirm,
      onSecondaryClick: handleCancel,
      primaryButton: confirmButton,
      secondaryButton: cancelButton,
      children: [header, content]
    }));
  };
  render.handledProps = [];
  return render();
};

/**
* Default props.
*/
CollectionListConfirm.handledProps = ["cancelButton", "confirmButton"];
CollectionListConfirm.defaultProps = {
  cancelButton: {
    content: 'Annuler',
    icon: 'cancel'
  },
  confirmButton: {
    content: 'Confirmer',
    icon: 'check',
    positive: true
  }
};
export default CollectionListConfirm;